export enum ToastType {
  SUCCESS = "success",
  ERROR = "error",
  WARN = "warn",
  INFO = "info",
}
